// @ts-nocheck
import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import classify from 'src/utils/classify';
import {CONSTANTS} from 'src/components/authentication/contants';
import IndexStore from 'src/stores/index';
import {ButtonTextExtraSmall} from '@spaced-out/ui-design-system/lib/components/Text';
import BrandingContainer from 'src/components/referrer-portal/authentication/container/branding-container';

import css from 'src/components/authentication/container/container.css';
import maincss from 'src/components/authentication/main.css';


type AuthenticationContainerProps = {
  children: React.ReactNode;
  senseStore: IndexStore;
};

const AuthenticationContainer = (props: AuthenticationContainerProps) => {
  const {t, makeKey} = useLabelTranslation();
  return (
    <div className={css.mainContainer}>
      <BrandingContainer />
      <div className={css.content}>
        <div className={css.chlidElement}>
          {React.cloneElement(props.children)}
        </div>
        <div className={css.footerSection}>
          <a href={CONSTANTS.PRIVACY_POLICY_LINK} target="_blank">
            <ButtonTextExtraSmall
              className={classify(css.privaryPolicy, maincss.underline)}
            >
              {t(
                makeKey(CONSTANTS.PRIVACY_POLICY_TEXT),
                CONSTANTS.PRIVACY_POLICY_TEXT,
              )}
            </ButtonTextExtraSmall>
          </a>
        </div>
      </div>
    </div>
  );
};

export default AuthenticationContainer;
